import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../../assets/help.png';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {}
}, null, -1);
const _hoisted_2 = [_hoisted_1];
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { getLocalPid } from "../../../libs/util";
export default {
  __name: 'click-where',
  setup(__props) {
    const pid = getLocalPid();
    const store = useStore();
    const token = computed(() => store.state.token);
    const userId = computed(() => store.state.userId);
    const sign = computed(() => store.state.sign);
    const getQueryVariable = variable => {
      const url = window.location.href;
      const query = url.split("?")[1];
      const vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (decodeURIComponent(pair[0]) == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      return false;
    };
    console.log("getQueryVariable", getQueryVariable("id"));
    let isDragging = false;
    let diffX = 0;
    let diffY = 0;
    const top = ref("30%");
    const left = ref("55%");
    let clickTimeout;
    const jumpToLiveClass = bAction => {
      if (bAction) {
        location.href = `https://readapi.bluebirdabc.com/lessondemo/index.html#/?userId=${userId.value}&token=${token.value}&sign=${sign.value}&pid=${pid}&articleId=${getQueryVariable("id")}`;
      }
    };
    const dragStart = e => {
      e.preventDefault();
      isDragging = false;
      clickTimeout = setTimeout(() => {
        isDragging = true;
      }, 200); // 设置一个阈值，例如 200 毫秒
      let ele = document.getElementById("source");
      if (e.type == "touchstart") {
        let _e = e.changedTouches[0];
        diffX = _e.clientX - ele.offsetLeft;
        diffY = _e.clientY - ele.offsetTop;
      } else if (e.type == "mousedown") {
        diffX = e.clientX - ele.offsetLeft;
        diffY = e.clientY - ele.offsetTop;
      }
    };
    const dragMove = e => {
      if (!isDragging) return;
      e.preventDefault();
      if (e.type == "touchmove") {
        let _e = e.changedTouches[0];
        left.value = _e.clientX - diffX + "px";
        top.value = _e.clientY - diffY + "px";
      } else if (e.type == "mousemove") {
        left.value = e.clientX - diffX + "px";
        top.value = e.clientY - diffY + "px";
      }
    };
    const dragEnd = () => {
      clearTimeout(clickTimeout);
      if (!isDragging) {
        jumpToLiveClass();
      }
      isDragging = false;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "position-fiexd position-relative",
        id: "source",
        draggable: "true",
        onMousedown: dragStart,
        onMousemove: dragMove,
        onMouseup: dragEnd,
        onDragstart: dragStart,
        onDragmove: dragMove,
        onDragend: dragEnd,
        onTouchstart: dragStart,
        onTouchmove: dragMove,
        onTouchend: dragEnd,
        onClick: _cache[0] || (_cache[0] = $event => jumpToLiveClass(false)),
        style: _normalizeStyle([{
          "z-index": "10",
          "display": "flex",
          "align-items": "center"
        }, 'top:' + top.value + ';left:' + left.value + ';'])
      }, _hoisted_2, 36);
    };
  }
};